export enum DocumentTypes {
    NONE = "None",
    REFERENCE_DOCUMENT =  "ReferenceDocument"
}